import { createSlice } from "@reduxjs/toolkit";
import redoScan from "@custom/rtk-apis/redo/redoScan";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const redoScanSlice = createSlice({
  name: "redoScanSlice",
  initialState,
  reducers: {
    closeModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(redoScan.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(redoScan.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(redoScan.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default redoScanSlice.reducer;
export const { closeModal } = redoScanSlice.actions;
